import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    accountId: Number,
    applicationId: Number
  }
  static targets = ["form", "button"]

  generate() {
    // Show the date selection form
    this.formTarget.classList.remove('hidden')
    this.buttonTarget.textContent = 'Cancel'
    this.buttonTarget.removeEventListener('click', this.generate)
    this.buttonTarget.addEventListener('click', this.cancel.bind(this))
  }

  cancel() {
    this.formTarget.classList.add('hidden')
    this.buttonTarget.textContent = 'Generate Statement'
    this.buttonTarget.removeEventListener('click', this.cancel)
    this.buttonTarget.addEventListener('click', this.generate.bind(this))
  }

  async submitForm(event) {
    event.preventDefault()
    
    const formData = new FormData(event.target)
    const submitButton = event.target.querySelector('button[type="submit"]')
    const originalText = submitButton.textContent
    
    try {
      submitButton.textContent = 'Generating...'
      submitButton.disabled = true
      
      const payload = {
        account_id: this.accountIdValue,
        start_date: this.formatDate(formData.get('start_date')),
        end_date: this.formatDate(formData.get('end_date'))
      }
      
      if (this.applicationIdValue) {
        payload.charity_care_application_id = this.applicationIdValue
      }
      
      const response = await fetch('/api/v1/stripe_financial_connections/generate_statement', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify(payload)
      })
      
      const result = await response.json()
      
      if (result.success) {
        this.showSuccess('Bank statement generation started. You will be notified when it\'s complete.')
        this.cancel()
      } else {
        this.showError(result.error || 'Failed to generate statement')
      }
    } catch (error) {
      console.error('Error generating statement:', error)
      this.showError('Failed to generate statement')
    } finally {
      submitButton.textContent = originalText
      submitButton.disabled = false
    }
  }

  formatDate(dateString) {
    // Handle the date format from Rails date_select
    return dateString
  }

  showError(message) {
    alert(`Error: ${message}`)
  }

  showSuccess(message) {
    alert(`Success: ${message}`)
  }
}